import { Component, computed, input, viewChild } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';

export interface SideNavMenuOption {
  enabled: boolean;
  type: 'menu';
  label: string;
  icon: string;
  iconNamespace?: string;
  menu: {
    enabled: boolean;
    type: 'link' | 'action';
    label: string;
    icon?: string;
    iconNamespace?: string;
    link?: string;
    target?: string;
    action?: () => void;
  }[];
  onMenuOpen: () => void;
  onMenuClose: () => void;
}

@Component({
  selector: 'app-sidenav-menu-option',
  templateUrl: './sidenav-menu-option.component.html',
  styleUrls: ['./sidenav-menu-option.component.scss'],
  standalone: false,
})
export class SidenavMenuOptionComponent {
  option = input<SideNavMenuOption>();
  collapsed = input<boolean>();

  protected readonly menuOptions = computed(() => this.option()?.menu?.filter((item) => item.enabled) ?? []);

  menuTrigger = viewChild<MatMenuTrigger>(MatMenuTrigger);

  onButtonClick(event: MouseEvent): void {
    event.stopPropagation();
    this.menuTrigger().openMenu();
  }

  handleMenuOpened(): void {
    this.option().onMenuOpen?.();
  }

  handleMenuClosed(): void {
    this.option().onMenuClose?.();
  }
}
